import React, { useState } from "react";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import EditIcon from "../../../assets/icons/editIcon.svg";
import { getNairaFormat } from "../../../utils/Utils";
import { useParams } from "react-router-dom";
import { setLoadingState } from "../../../redux/AppSlice";
import { useDispatch } from "react-redux";
import { onUpdateAsset, onUpdateInvestorFinance, updateLogObject } from "../utils";
// import { TabList } from "../data";

/* eslint-disable react/prop-types */
const ActionSideBar = ({
	requestData,
	action,
	setAction,
	handleCancel,
	canEditStatus,
	updatedData,
	isEditable,
	options,
	keyValue = "assetInfo",
	assetDateToUpdate,
}) => {
	// let navigate = useNavigate();
	let { category, id: objectId, filter } = useParams();
	const dispatch = useDispatch();
	const [productStatus, setProductStatus] = useState(requestData?.logisticStatus || "");
	const isLeasing = filter === "lease";

	const handleEdit = () => {
		setAction("edit");
	};

	const handleUpdate = () => {
		if (isLeasing) {
			updateCurrentObject();
		} else {
			updateAfData();
		}
	};

	const handleStatusChange = (e) => {
		setProductStatus(e.target.value);
	};

	// const handleStatusChange = (e) => {
	// 	setProductStatus(e.target.value);
	// 	console.log(e.target.value);
	// 	dispatch(setLoadingState(true));

	// 	let value = e.target.value;
	// 	let newCategory = "";
	// 	let data = {};

	// 	if (value === "Procured") {
	// 		newCategory = "procured_assets";
	// 		data = { approvalStatus: "approved" };
	// 	} else if (value === "Deployed") {
	// 		newCategory = "deployed_assets";
	// 		data = { deployed: true };
	// 	} else if (value === "Maintained") {
	// 		newCategory = "maintained_assets";
	// 		data = { maintenance: true };
	// 	} else if (value === "Inspected") {
	// 		newCategory = "inspected_assets";
	// 		data = { inspection: true };
	// 	} else if (value === "Retained") {
	// 		newCategory = "retained_assets";
	// 		data = { retainmentStatus: "retained" };
	// 	} else if (value === "Repaired") {
	// 		newCategory = "repaired_assets";
	// 		data = { repair: true };
	// 	} else if (value === "Awaiting Purchase") {
	// 		newCategory = "awaiting_purchase";
	// 		data = { approvalStatus: "pending" };
	// 	} else if (value === "Retrieved") {
	// 		newCategory = "retrieved_assets";
	// 		// data = { approvalStatus: "pending" };
	// 	} else if (value === "Reassigned") {
	// 		newCategory = "reassigned_assets";
	// 		// data = { approvalStatus: "pending" };
	// 	} else if (value === "Sold") {
	// 		newCategory = "sold_assets";
	// 	}

	// 	const response = updateLogObject(objectId, data, filter);
	// 	response
	// 		.then((res) => {
	// 			// console.log(res)
	// 			dispatch(setLoadingState(false));
	// 			if (res?.error) {
	// 				toast.error(res?.error || "Error updating status!");
	// 				return;
	// 			}
	// 			toast.success("Status updated successfully!");
	// 			setTimeout(() => {
	// 				navigate(`/logistics/${newCategory}`, { replace: true });
	// 			}, 800);
	// 		})
	// 		.catch((err) => {
	// 			console.log(err);
	// 			dispatch(setLoadingState(false));
	// 			toast.error(err?.error || "Error updating status!");
	// 		});
	// };

	const getData = () => {
		let data = {};
		if (updatedData) {
			if (isLeasing) {
				data = updatedData?.lease || updatedData?.leaseData;
				return {
					...data,
					logisticStatus: productStatus ? productStatus?.toLowerCase() : requestData?.logisticStatus,
				};
			} else {
				data = updatedData?.AF || updatedData?.AfData;
				return {
					...data,
					logisticStatus: productStatus ? productStatus?.toLowerCase() : requestData?.logisticStatus,
				};
			}
		} else {
			return {
				logisticStatus: productStatus
					? productStatus
						? productStatus?.toLowerCase()
						: requestData?.logisticStatus
					: requestData?.logisticStatus,
			};
		}
	};

	const data = getData();
	console.log(data);

	const assetData = {
		[keyValue]: assetDateToUpdate,
		logisticStatus: data?.logisticStatus,
	};

	delete assetData?.assetInfo;

	const getStatus = () => {
		if (productStatus === "awaiting_purchase" && requestData?.productCategory === "Vehicles") {
			return true;
		}
		if (productStatus === "" && requestData?.productCategory === "Vehicles") {
			return true;
		} else {
			return false;
		}
	};

	// console.log(getStatus());

	// const getNextTab = () => {
	// 	const findA = TabList.find((a) => a.id === category);

	// 	const index = TabList.findIndex((a) => findA?.id === a.id);

	// 	return TabList[index + 1];
	// };

	// console.log(productStatus, requestData?.logisticStatus, requestData);

	const updateCurrentObject = async () => {
		if (getStatus()) {
			if (data?.vehicleInfo?.chassisNum === "" || data?.vehicleInfo?.engineNum === "") {
				toast.error("Engine Number or chassis number cannot be empty");
				return;
			}
			if (!data?.vehicleInfo?.assetInvoice) {
				toast.error("Please upload asset invoice");
				console.log("no");
				return;
			}
		} else if (
			requestData?.productCategory !== "Vehicles" &&
			requestData?.logisticStatus === undefined &&
			!data?.assetInvoice
		) {
			toast.error("Please upload asset Invoice");
			console.log("yes");
			return;
		} else if (
			requestData?.logisticStatus === "awaiting procurement" &&
			requestData?.productCategory === "Vehicles" &&
			!data?.vehicleInfo?.hardCopyReceipt
		) {
			toast.error("Please upload hard copy receipt received from vendor");
			return;
		} else if (
			requestData?.logisticStatus === "awaiting procurement" &&
			requestData?.productCategory !== "Vehicles" &&
			!data?.hardCopyReceipt
		) {
			toast.error("Please upload hard copy receipt received from vendor");
			return;
		} else if (
			requestData?.logisticStatus === "procured" &&
			requestData?.productCategory === "Vehicles" &&
			data?.deliveryInfo?.deliveryFee === ""
		) {
			toast.error("Please update delivery fee");
			return;
		}

		if (data?.logisticStatus === "" || data?.logisticStatus === "---" || !data?.logisticStatus) {
			toast.error("Request status cannot be empty");
			return;
		}

		dispatch(setLoadingState(true));

		console.log("submitted: ", objectId, data, filter);

		const newData = {
			[keyValue]: data,
			logisticStatus: data?.logisticStatus,
		};

		if (requestData?.assetObj) {
			const resData = await onUpdateAsset(requestData?.assetObj?.id, newData);
			console.log(resData);
		}

		const response = updateLogObject(objectId, data, filter);

		response
			.then((res) => {
				console.log(res);
				dispatch(setLoadingState(false));
				if (res?.error) {
					toast.error(res?.error || "Error updating Object!");
					return;
				}
				setAction("view");

				toast.success("Logistics updated successfully!");

				setTimeout(() => {
					window.location.href = `/logistics/${category}`;
				}, 1000);
			})
			.catch((err) => {
				console.log(err);
				dispatch(setLoadingState(false));
				toast.error(err?.error || "Error updating Object!");
			});
	};

	const updateAfData = async () => {
		if (!requestData?.logisticStatus === undefined && !data?.paymentReceipt) {
			toast.error("Please upload receipt of payment");
			return;
		}
		if (requestData?.logisticStatus === "awaiting procurement" && !data?.hardCopyReceipt) {
			toast.error("Please upload proof of product purchase received from vendor.");
			return;
		}
		if (requestData?.logisticStatus === "procured" && !data?.deliveryInfo) {
			toast.error("Please update delivery information.");
			return;
		}
		if (data?.logisticStatus === "deployed" && data?.deliveryInfo?.deliveryFeeStatus === "pending") {
			toast.error("Asset cannot be deployed until delivery fee payment.");
			return;
		}
		if (data?.logisticStatus === "" || data?.logisticStatus === "---" || !data?.logisticStatus) {
			toast.error("Request status cannot be empty");
			return;
		}

		dispatch(setLoadingState(true));

		if (requestData?.requestType === "old") {
			const resData = await onUpdateInvestorFinance(requestData?.investorFinanceInfo?.financeId, data);
			console.log(resData);
		}

		const response = updateLogObject(objectId, data, filter);

		response
			.then((res) => {
				console.log(res);
				dispatch(setLoadingState(false));
				if (res?.error) {
					toast.error(res?.error || "Error updating Object!");
					return;
				}
				setAction("view");

				toast.success("Logistics updated successfully!");

				setTimeout(() => {
					window.location.href = `/logistics/${category}`;
				}, 1000);
			})
			.catch((err) => {
				console.log(err);
				dispatch(setLoadingState(false));
				toast.error(err?.error || "Error updating Object!");
			});
	};

	return (
		<div className='LeftSection'>
			<div className='productDetails'>
				{isLeasing ? (
					<>
						<img src={requestData?.image || "/images/placeholder_img.jpg"} alt='product' />
						<h6>{requestData?.productName || requestData?.productId?.productName}</h6>
						<p>{getNairaFormat(requestData?.amount)}</p>
					</>
				) : (
					<>
						<img src={requestData?.productPhotos?.[0]?.url || "/images/placeholder_img.jpg"} alt='product' />
						<h6 style={{ textTransform: "capitalize" }}>{requestData?.businessType || "---"}</h6>
						<p>{getNairaFormat(requestData?.amountToRaise)}</p>
					</>
				)}
			</div>

			{canEditStatus && (
				<div className='mb-6'>
					<SelectFieldStatusALT
						productStatus={productStatus}
						handleStatusChange={handleStatusChange}
						isEditable={isEditable}
						selectOptions={options}
					/>
				</div>
			)}

			{action &&
				(action === "view" ? (
					<Button
						variant='outlined'
						className='editButton w-full'
						onClick={handleEdit}
						startIcon={<img src={EditIcon} alt='edit icon' />}>
						Edit Details
					</Button>
				) : (
					<>
						<Button onClick={handleUpdate} variant='contained' className='updateButton w-full' type='submit'>
							Update
						</Button>
						<Button
							variant='outlined'
							className='cancelButton w-full'
							onClick={() => {
								setProductStatus("");
								handleCancel();
							}}>
							Cancel
						</Button>
					</>
				))}
		</div>
	);
};

const SelectFieldStatusALT = ({ productStatus, handleStatusChange, isEditable, selectOptions }) => {
	const options = ["Maintained", "Inspected", "Retained", "Retrieved", "Reassigned", "Repaired", "Sold"];

	const optionsToUse = selectOptions ? selectOptions : options;

	return (
		<select
			className='edit w-full'
			name='productStatus'
			value={productStatus}
			onChange={handleStatusChange}
			disabled={!isEditable}>
			<option value=''>---</option>
			{optionsToUse.map((option) => (
				<option key={option} value={option}>
					{option}
				</option>
			))}
		</select>
	);
};

export default ActionSideBar;
